module.exports = __webpack_public_path__ + "fonts/sourcesanspro-bold-webfont.a7860c62.woff";